import { useMemo } from 'react';
import { useSearchParams } from 'react-router';
import { contentTypePluralToOneMap } from '../types/types';

export default function useContentSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const category = useMemo(() => {
    return searchParams.get('category') ?? undefined;
  }, [searchParams]);

  const contentTypePlural = useMemo(() => {
    return searchParams.get('contentType') ?? undefined;
  }, [searchParams]);

  const contentType = useMemo(() => {
    return contentTypePlural
      ? contentTypePluralToOneMap[contentTypePlural]
      : undefined;
  }, [contentTypePlural]);

  const updateSearchParam = (key: string, value?: string | string[]) => {
    if (Array.isArray(value)) {
      searchParams.delete(key);
      value.forEach((v) => searchParams.append(key, v));
    } else if (value) {
      searchParams.set(key, value);
    } else {
      searchParams.delete(key);
    }

    setSearchParams(searchParams);
  };

  const updateCategory = (newCategory?: string) => {
    updateSearchParam('category', newCategory);
  };

  return {
    updateSearchParam,
    category,
    contentTypePlural,
    contentType,
    updateCategory,
  };
}
